import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { getBuildIdQuery } from '@ncg/data';
import { TranslateModule } from '@ngx-translate/core';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { SettingsService } from '../../../../core/settings.service';
import { FavoritesService } from '../../../../favorites-service/favorites.service';

@Component({
    selector: 'ncg-favorites-page-link',
    template: `
        <a
            *ngIf="(settingsService.settings$ | async)?.favoritesLink?.url as favoritesUrl"
            class="favorites-page-link button button is-primary"
            [ngClass]="linkClass"
            [routerLink]="favoritesUrl"
            [attr.title]="'favorites.link_to_page' | translate"
        >
            <svg-icon-sprite
                [src]="'assets/images/sprite.svg' + buildIdQuery + '#heart'"
                [viewBox]="'0 0 30 30'"
                [width]="'30px'"
                [height]="'30px'"
                aria-hidden="true"
                class="favorites-page-link__icon"
                [ngClass]="iconClass"
            ></svg-icon-sprite>
            <span class="favorites-page-link__text" [ngClass]="textClass">
                {{ 'favorites.link_to_page' | translate }}
            </span>
            <span *ngIf="showCount && (favoritesService.favorites$ | async)?.length as count" class="favorites-page-link__count">{{ count }}</span>
        </a>
    `,
    styleUrls: ['./favorites-page-link.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, TranslateModule, IconSpriteModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FavoritesPageLinkComponent {
    public buildIdQuery = getBuildIdQuery();
    @Input()
    public linkClass?: string;

    @Input()
    public textClass?: string;

    @Input()
    public iconClass?: string;

    @Input()
    public showCount?: boolean = false;

    constructor(
        public readonly settingsService: SettingsService,
        public readonly favoritesService: FavoritesService
    ) {}
}
